import { UpdatePartnerMaterialRequestSchema, UpdatePartnerMaterialResponseSchema } from './update-partner-material.schema';
export const updatePartnerMaterialContract = {
    method: 'PATCH',
    path: '/api/v2/admin/partner-materials/:id',
    description: 'Update a partner material',
    requestSchema: UpdatePartnerMaterialRequestSchema,
    responseSchema: UpdatePartnerMaterialResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin only',
            404: 'Partner material not found'
        }
    }
};

//# sourceMappingURL=update-partner-material.contract.js.map